export default __webpack_public_path__ + "static/media/SecularOne-Regular.9613dd3f.ttf";